import { useEffect, useRef } from 'react';

import { Carousel, Skeleton } from 'antd';
import { CarouselRef } from 'antd/es/carousel';

import { isSubdomain } from '@/helpers/domian';
import { useGetBannerQuery } from '@/services/resume';
import styled from '@/styled';

import Offer from './Banners/Default';
import Institucional from './Banners/Institucional';
import PortalConfig from './Banners/Portal';
import CarouselDots from './Dots';

interface CarouselOffersProps {
  className?: string;
}

const CarouselOffers = ({ className }: CarouselOffersProps) => {
  const { data, isLoading } = useGetBannerQuery('');
  const carrouselRef = useRef<CarouselRef>();

  const goTo = (slide: number) => {
    carrouselRef.current.goTo(slide, false);
  };

  useEffect(() => {
    carrouselRef.current.autoPlay('update');
  }, []);

  const defaultProps = {
    className,
    customPaging: (index: number) => <CarouselDots goTo={() => goTo(index)} />,
    draggable: true,
    swipeToSlide: true,
    waitForAnimate: true,
    autoplay: true,
    ref: carrouselRef,
    autoplaySpeed: 8000
  };

  if (isLoading) {
    return (
      <div className={className}>
        <Carousel {...defaultProps}>
          <div className='carouselContent'>
            <Skeleton.Image className='carouselContent' style={{ width: '100vw', height: '45vh' }} />
          </div>
        </Carousel>
      </div>
    );
  }

  return (
    <div className={className}>
      <Carousel {...defaultProps}>
        {!isSubdomain() && <Institucional />}
        {data?.schoolConfig && <PortalConfig schoolConfig={data?.schoolConfig} />}
        {data?.upsell?.map(offer => (
          <Offer key={offer.id} upsell={offer} />
        ))}
      </Carousel>
    </div>
  );
};

export default styled(CarouselOffers)`
  margin-bottom: ${({ theme }) => theme.space.spacing(15)};
  width: 100%;

  li {
    width: 28px !important;
  }

  .slick-dots {
    z-index: 1;
  }

  .ant-typography {
    margin: 0;
  }
`;
